import { useEffect } from 'react';

export function useTheme(isAuthenticated: boolean, themeColor?: string, themeMode?: 'light' | 'dark', fontScale?: number) {
  useEffect(() => {
    if (!isAuthenticated) return;

    const colors: Record<string, any> = {
      blue: { 50: '#f0f9ff', 100: '#e0f2fe', 500: '#0ea5e9', 600: '#0284c7', 700: '#0369a1', 900: '#0c4a6e' },
      green: { 50: '#f0fdf4', 100: '#dcfce7', 500: '#22c55e', 600: '#16a34a', 700: '#15803d', 900: '#14532d' },
      violet: { 50: '#f5f3ff', 100: '#ede9fe', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9', 900: '#4c1d95' },
      orange: { 50: '#fff7ed', 100: '#ffedd5', 500: '#f97316', 600: '#ea580c', 700: '#c2410c', 900: '#7c2d12' },
      rose: { 50: '#fdf2f8', 100: '#fce7f3', 500: '#ec4899', 600: '#db2777', 700: '#be185d', 900: '#831843' },
    };

    const theme = themeColor || 'blue';
    const palette = colors[theme] || colors.blue;

    const root = document.documentElement;

    try {
      const mode = themeMode || 'light';
      if (mode === 'dark') root.classList.add('dark');
      else root.classList.remove('dark');
    } catch {}

    root.style.setProperty('--brand-50', palette[50]);
    root.style.setProperty('--brand-100', palette[100]);
    root.style.setProperty('--brand-500', palette[500]);
    root.style.setProperty('--brand-600', palette[600]);
    root.style.setProperty('--brand-700', palette[700]);
    root.style.setProperty('--brand-900', palette[900]);
 
    try {
      const s0 = typeof fontScale === 'number' ? fontScale : Number(fontScale || 1);
      const s = Number.isFinite(s0) ? Math.min(1.5, Math.max(0.8, s0)) : 1;
      root.style.fontSize = `${16 * s}px`;
    } catch {}
  }, [isAuthenticated, themeColor, themeMode, fontScale]);
}
